import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import { EditTwoTone, DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'

const MenuList = ({
  data, isLoading, handleDelete,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: text => text || '-',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'Target',
      dataIndex: 'target',
      key: 'target',
      render: text => text || '-',
    },
    {
      title: 'Order',
      dataIndex: 'order_no',
      key: 'order_no',
      render: text => text || '-',
    },
    {
      title: 'Parent',
      dataIndex: 'parent',
      key: 'parent',
      render: text => (text ? text?.title : '-'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditTwoTone twoToneColor="#faad14" className="mr-2" onClick={() => history.push(`/menu/${record.id}/edit`)} />
          {['/kunjungi', '/bantuan-pemerintah', '/pelajari', '/ikuti']?.includes(record.url) ?
            <DeleteTwoTone twoToneColor="#c1c1c1" className="cursor-no-drop"/>
          :
            <Popconfirm
              title="Are you sure delete this Menu?"
              okText="Yes"
              cancelText="No"
              placement="topLeft"
              onConfirm={() => handleDelete(record.id)}
            >
              <DeleteTwoTone twoToneColor="#ff4d4f" />
            </Popconfirm>
          }
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">Menu List</h3>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => history.push('/menu/add')}>
            Add Menu
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={false}
      />
    </div>
  )
}

MenuList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
}

export default MenuList
